import { toast } from 'sonner'

interface ShareOptions {
	title?: string
	text?: string
	url: string
}

export async function shareOrCopy(
	options: ShareOptions,
	copyToClipboard: (text: string) => void,
) {
	if (
		typeof navigator !== 'undefined' &&
		navigator.share &&
		navigator.canShare &&
		navigator.canShare(options)
	) {
		try {
			await navigator.share(options)
			return true
		} catch (error) {
			if (error instanceof Error && error.name === 'AbortError') {
				return false
			}
			console.error('Share failed, falling back to copy:', error)
		}
	}

	// Fallback to copy
	try {
		const shareText = options.text
			? `${options.text} ${options.url}`
			: options.url
		copyToClipboard(shareText)
		toast.success('Link copied to clipboard', {
			description:
				shareText.length > 50 ? `${shareText.slice(0, 47)}...` : shareText,
		})
	} catch (err) {
		console.error('Failed to copy text: ', err)
	}
	return false
}
